import React from 'react'
import { Box } from '@mui/material'
import { TeacherProvider } from 'common/context/TeacherContext'
import { Routes, Route } from 'react-router-dom'

import Awakening from './awakening'
import AwakeningStepperComponent from './awakening/stepper'
import TermsOfServiceComponent from './awakening/termsOfService'

function TeacherApp() {
  // console.log('teacher app')
  return (
    <TeacherProvider>
      <Routes>
        <Route
          path='/awakening/stepper'
          element={<AwakeningStepperComponent />}
        />
        <Route path='/awakening' element={<Awakening />} />
        <Route
          path='/awakening/terms-of-service'
          element={<TermsOfServiceComponent />}
        />
        <Route path='*' element={<Box>Hello world! This is XM React</Box>} />
      </Routes>
    </TeacherProvider>
  )
}

export default TeacherApp
